import { ColumnDef } from "@tanstack/react-table"
import { format } from "date-fns"

import { BillingUserInfoType } from "@/types/billing"

import { DataTableColumnHeader } from "../../data-table"
import { BillingUserInfoOperation } from "../operations/billing-user-info-operation"

export const billingUserInfoColumns: ColumnDef<BillingUserInfoType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.id}</div>
    },
  },
  {
    accessorKey: "user",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="User" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.username}</div>
    },
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.email}</div>
    },
  },
  {
    accessorKey: "first_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="First Name" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.first_name}</div>
    },
  },
  {
    accessorKey: "last_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Last Name" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.last_name}</div>
    },
  },
  {
    accessorKey: "initials",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Initials" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.initials}</div>
    },
  },
  {
    accessorKey: "address",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Address" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.address}</div>
    },
  },
  {
    accessorKey: "gender",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Gender" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.gender}</div>
    },
  },
  {
    accessorKey: "mobile_number",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Mobile Number" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.mobile_number}</div>
    },
  },
  {
    accessorKey: "department",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Department" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.department}</div>
    },
  },
  {
    accessorKey: "position",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Position" />
    ),
    cell: ({ row }) => {
      return <div className="print:text-xl">{row.original.position}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <BillingUserInfoOperation data={row.original} />
        </div>
      )
    },
  },
]
